import type PersonalDetails from '../../../contracts/PersonalDetails';
import type { PurchasesResponse } from '../../../contracts/Purchase';
import type UserProfileData from '../../../contracts/UserProfileData';
import { AsyncState } from '../../../store/types';

export type UserProfileDataState = AsyncState & Partial<UserProfileData>;

export type PersonalDetailsState = {
  entities: PersonalDetails | null;
  purchases: PurchasesResponse | null;
  showPersonalDetails: AsyncState;
  updateAddress: AsyncState;
  updateContactsDetails: AsyncState;
  updatePassword: AsyncState;
  updatePersonalInformation: AsyncState;
  updateUserProfileData: AsyncState;
  userProfileData: UserProfileDataState;
};

const FETCH_PERSONAL_DETAILS_BEGIN = 'account/PersonalDetails/FETCH_PERSONAL_DETAILS_BEGIN';
const FETCH_PERSONAL_DETAILS_SUCCESS = 'account/PersonalDetails/FETCH_PERSONAL_DETAILS_SUCCESS';
const FETCH_PERSONAL_DETAILS_FAILURE = 'account/PersonalDetails/FETCH_PERSONAL_DETAILS_FAILURE';
const FETCH_PERSONAL_DETAILS_DISMISS_ERROR =
  'account/PersonalDetails/FETCH_PERSONAL_DETAILS_DISMISS_ERROR';
const UPDATE_PERSONAL_INFORMATION_BEGIN =
  'account/PersonalDetails/UPDATE_PERSONAL_INFORMATION_BEGIN';
const UPDATE_PERSONAL_INFORMATION_SUCCESS =
  'account/PersonalDetails/UPDATE_PERSONAL_INFORMATION_SUCCESS';
const UPDATE_PERSONAL_INFORMATION_FAILURE =
  'account/PersonalDetails/UPDATE_PERSONAL_INFORMATION_FAILURE';

const UPDATE_CONTACTS_DETAILS_BEGIN = 'account/PersonalDetails/UPDATE_CONTACTS_DETAILS_BEGIN';
const UPDATE_CONTACTS_DETAILS_SUCCESS = 'account/PersonalDetails/UPDATE_CONTACTS_DETAILS_SUCCESS';
const UPDATE_CONTACTS_DETAILS_FAILURE = 'account/PersonalDetails/UPDATE_CONTACTS_DETAULS_FAILURE';

const UPDATE_ADDRESS_BEGIN = 'account/PersonalDetails/UPDATE_ADDRESS_BEGIN';
const UPDATE_ADDRESS_SUCCESS = 'account/PersonalDetails/UPDATE_ADDRESS_SUCCESS';
const UPDATE_ADDRESS_FAILURE = 'account/PersonalDetails/UPDATE_ADDRESS_FAILURE';

const FETCH_PURCHASES_BEGIN = 'account/PersonalDetails/FETCH_PURCHASES_BEGIN';
const FETCH_PURCHASES_SUCCESS = 'account/PersonalDetails/FETCH_PURCHASES_SUCCESS';
const FETCH_PURCHASES_FAILURE = 'account/PersonalDetails/FETCH_PURCHASES_FAILURE';

const FETCH_USER_PROFILE_DATA_BEGIN = 'account/PersonalDetails/FETCH_USER_PROFILE_DATA_BEGIN';
const FETCH_USER_PROFILE_DATA_SUCCESS = 'account/PersonalDetails/FETCH_USER_PROFILE_DATA_SUCCESS';
const FETCH_USER_PROFILE_DATA_FAILURE = 'account/PersonalDetails/FETCH_USER_PROFILE_DATA_FAILURE';
const UPDATE_USER_PROFILE_DATA_BEGIN = 'account/PersonalDetails/UPDATE_USER_PROFILE_DATA_BEGIN';
const UPDATE_USER_PROFILE_DATA_SUCCESS = 'account/PersonalDetails/UPDATE_USER_PROFILE_DATA_SUCCESS';
const UPDATE_USER_PROFILE_DATA_FAILURE = 'account/PersonalDetails/UPDATE_USER_PROFILE_DATA_FAILURE';

export {
  FETCH_PERSONAL_DETAILS_BEGIN,
  FETCH_PERSONAL_DETAILS_SUCCESS,
  FETCH_PERSONAL_DETAILS_FAILURE,
  FETCH_PERSONAL_DETAILS_DISMISS_ERROR,
  UPDATE_PERSONAL_INFORMATION_BEGIN,
  UPDATE_PERSONAL_INFORMATION_SUCCESS,
  UPDATE_PERSONAL_INFORMATION_FAILURE,
  UPDATE_CONTACTS_DETAILS_BEGIN,
  UPDATE_CONTACTS_DETAILS_SUCCESS,
  UPDATE_CONTACTS_DETAILS_FAILURE,
  UPDATE_ADDRESS_BEGIN,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  FETCH_PURCHASES_BEGIN,
  FETCH_PURCHASES_SUCCESS,
  FETCH_PURCHASES_FAILURE,
  FETCH_USER_PROFILE_DATA_BEGIN,
  FETCH_USER_PROFILE_DATA_SUCCESS,
  FETCH_USER_PROFILE_DATA_FAILURE,
  UPDATE_USER_PROFILE_DATA_BEGIN,
  UPDATE_USER_PROFILE_DATA_SUCCESS,
  UPDATE_USER_PROFILE_DATA_FAILURE
};
